import React from 'react';
import View from './View';
import { SelectionProvider } from './SelectionContext';
import { ListContextProvider } from './ListContext';

const ListDetailView = (props) => {
  const {
    onMount,
    queryValName,
    getSelfLink,
    linkUrl,
    metaOverride,
    ...rest
  } = props;

  return (
    <ListContextProvider
      linkUrl={linkUrl}
    >
      <SelectionProvider
        initialState={{
          queryValName,
          getSelfLink,
          metaOverride,
        }}
        onFetch={onMount}
      >
        <View {...rest} />
      </SelectionProvider>
    </ListContextProvider>
  );
};

export default ListDetailView;
